/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.914 13.9a4.003 4.003 0 013.18-1.56h.043a3.994 3.994 0 11-3.994 3.994c.003-.429.079-.855.223-1.26l-4.792-2.511a3.994 3.994 0 110-4.757l4.732-2.417c-.131-.39-.2-.798-.206-1.209a3.977 3.977 0 11.789 2.357l-4.74 2.417c.129.39.198.798.205 1.209-.003.43-.079.855-.223 1.26l4.783 2.477zm5.889-9.72a2.709 2.709 0 00-2.709-2.708 2.717 2.717 0 00-2.708 2.708 2.709 2.709 0 005.417 0zM4.36 12.872a2.709 2.709 0 112.709-2.709 2.717 2.717 0 01-2.71 2.709zm9.026 3.462a2.709 2.709 0 002.708 2.709 2.717 2.717 0 002.709-2.709 2.709 2.709 0 10-5.417 0z" _fill="#352727"/>'
  }
})
